// "Read with AI" on a document / certificate form: the uploaded file goes through the certificate reader (/api/extract-cert)
// and the answer fills the form. Nothing is saved here - the user checks the fields and presses Save.

// form field -> reader field
export const SHIP_DOC_FIELDS = { 'Title': 'Title', 'Document Type': 'Type', 'Expiry Date': 'Expiry Date', 'Survey Due': 'Survey Due', 'Notes': 'Notes' }
export const CREW_CERT_FIELDS = { 'Title': 'Title', 'Type': 'Type', 'Doc ID': 'Doc ID', 'Issued Date': 'Issued Date', 'Expiry Date': 'Expiry Date', 'Notes': 'Notes' }
const isDateField = k => /date|due/i.test(k)
const isDate = v => /^\d{4}-\d{2}-\d{2}$/.test(v)

// overwrite = false (automatic read after upload): only empty fields (a field still at its new-form default counts as empty);
// true ("Read with AI" button): every field the reader found
export function fillFromAi(form, ai, fields, { overwrite = false, defaults = {} } = {}) {
  const next = { ...form }, filled = []
  for (const [k, src] of Object.entries(fields)) {
    const v = String((ai && ai[src]) ?? '').trim()
    if (!v || v === '-' || (isDateField(k) && !isDate(v))) continue
    if (!overwrite && String(form[k] ?? '').trim() && String(form[k]) !== String(defaults[k] ?? '\u0000')) continue
    if (String(form[k] ?? '') === v) continue
    next[k] = v; filled.push(k)
  }
  return { form: next, filled }
}

// kind: 'ship' (Documents page) | 'crew' (crew certificate); fileUrl = the uploaded file of this vessel
export async function readDocWithAi(fileUrl, kind, clientId, fetchFn = fetch) {
  if (!fileUrl) throw new Error('Upload the PDF first')
  const r = await fetchFn('/api/extract-cert', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ fileUrl, kind, ...(clientId ? { client_id: clientId } : {}) }) })
  const j = await r.json().catch(() => ({}))
  if (!r.ok || j.error) throw new Error(j.error || ('The AI could not read it (' + r.status + ')'))
  return j
}
export const filledNote = filled => (filled.length ? 'AI filled: ' + filled.join(', ') + ' - check them, then Save.' : 'The AI found nothing new to fill - check the document.')
